import addValidationMessage from '../utils/translation/addValidationMessage';
import requiredValidator from './requiredValidator';

addValidationMessage('Core/postalCodeValidator', 'postalCode', {
  fr: 'Le code postal n\'est pas valide',
  en: 'The postal code is not valid',
});

const postalCodeValidator = (value: string) => {
  if (!requiredValidator(value)) {
    return true;
  }

  return /^[ABCEFGHJKLMNPRSTVXY][0-9][ABCEFGHJKLMNPRSTVWXYZ][ ]?[0-9][ABCEFGHJKLMNPRSTVWXYZ][0-9]$/.test(value);
};

/**
 * @component
 * @visibleName postalCodeValidator
 */
export default postalCodeValidator;
